// extracted by mini-css-extract-plugin
export default {"classes":"Robotest_classes__eE5vv","errorText":"Robotest_errorText__drCdw","btnDiv":"Robotest_btnDiv__GPPIu","bgGreen":"Robotest_bgGreen__gpUWy","bgRed":"Robotest_bgRed__Rzs-R"};